import React from 'react';

// --- Icon Components ---
// Icons tailored for the Delivery Policy content.

const DeliveryIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
    </svg>
);

const ServiceAreaIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064"></path>
    </svg>
);

const DelayIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
    </svg>
);

const SupportIcon = () => (
    <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"></path>
    </svg>
);


// --- Reusable Section Component ---
// This component structures each policy point, matching the T&C page design.
const Section = ({ title, icon, children }) => (
  <div className="mb-8">
    <div className="flex items-center mb-3">
        {/* Icon wrapper to control size and color */}
        <div className="w-6 h-6 mr-3 text-indigo-500">
            {icon}
        </div>
      <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
    </div>
    <div className="pl-9 text-gray-600 leading-relaxed">
      {children}
    </div>
  </div>
);

// --- Main Page Component ---
const DeliveryPolicyPage = () => {
    
  const policyItems = [
    {
      title: "Efficient Daily Delivery",
      description: "Our chefs and delivery partners dispatch meals same day, typically within your selected time slot.",
      icon: <DeliveryIcon />,
    },
    {
      title: "Wide Service Area",
      description: "BentoBox delivers across our defined service zones—if you're within the active delivery patch, we'll reach you.",
      icon: <ServiceAreaIcon />,
    },
    {
      title: "Handling Delays",
      description: "If delays occur due to traffic, weather, or unforeseen circumstances, our app notifies you immediately.",
      icon: <DelayIcon />,
    },
    {
      title: "Contact Support Anytime",
      description: "Need help or have a question? Our support team is just a tap away from inside the app.",
      icon: <SupportIcon />,
    }
  ];

  return (
    <div className="!pt-28 md:!pt-32 bg-gray-100 font-sans p-4 sm:p-6 md:p-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="p-8 sm:p-12">
          <header className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight">Delivery Policy</h1>
            <p className="mt-4 text-lg text-gray-500 max-w-2xl mx-auto">
              Your meals deserve to arrive <span className="font-semibold text-indigo-600">warm</span>, <span className="font-semibold text-indigo-600">fresh</span>, and <span className="font-semibold text-indigo-600">on time</span>.
            </p>
          </header>

          <main>
            {policyItems.map((item, index) => (
              <Section key={index} title={item.title} icon={item.icon}>
                {item.description}
              </Section>
            ))}
          </main>
        </div>
      </div>
      
      {/* Contact CTA Section */}
      <div className="max-w-5xl mx-auto mt-10">
          <div className="bg-white rounded-2xl shadow-xl p-6 text-center">
            <h3 className="text-lg font-bold text-slate-900">Questions About Delivery?</h3>
            <p className="mt-1 text-base text-slate-600">Our support team is ready to help ensure your experience is perfect.</p>
            <a
              href="mailto:support@getbentobox.in"
              className="inline-block mt-4 px-6 py-2 bg-indigo-600 text-white font-semibold text-sm rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Contact Support
            </a>
          </div>
      </div>
    </div>
  );
};

export default DeliveryPolicyPage;


// import React from 'react'

// const DeliveryPolicy = () => {
//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 relative overflow-hidden">
      
//       {/* Animated Background Elements */}
//       <div className="absolute inset-0">
//         <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
//         <div className="absolute top-40 right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
//         <div className="absolute -bottom-8 left-20 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-4000"></div>
//       </div>

//       {/* Main Content */}
//       <div className="relative z-10 px-6 py-5">
        
//         {/* Header with Flowing Design */}
//         <div className="text-center mb-10 lg:mb-20">
//           <div className="inline-block relative">
//             <h1 className="text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 mb-6">
//               Delivery
//             </h1>
//             <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-32 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
//           </div>
//           <p className="text-xl text-gray-700 mt-8 max-w-3xl mx-auto leading-relaxed">
//             Your meals deserve to arrive <span className="font-bold text-blue-600">warm</span>, 
//             <span className="font-bold text-green-600"> fresh</span>, and 
//             <span className="font-bold text-purple-600"> on time</span>
//           </p>
//         </div>

//         {/* Flowing Policy Items */}
//         <div className="max-w-7xl mx-auto">
//           <div className="grid lg:grid-cols-2 gap-16 items-center">
            
//             {/* Left Column */}
//             <div className="space-y-12">
              
//               {/* Policy Item 1 */}
//               <div className="flex items-start space-x-6 group">
//                 <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
//                   <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
//                   </svg>
//                 </div>
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
//                     Efficient Daily Delivery
//                   </h3>
//                   <p className="text-gray-600 text-base leading-relaxed lg:text-lg">
//                     Our chefs and delivery partners dispatch meals same day, typically within your selected time slot.
//                   </p>
//                 </div>
//               </div>

//               {/* Policy Item 2 */}
//               <div className="flex items-start space-x-6 group ml-12">
//                 <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
//                   <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064" />
//                   </svg>
//                 </div>
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-green-600 transition-colors">
//                     Wide Service Area
//                   </h3>
//                   <p className="text-gray-600 text-base leading-relaxed lg:text-lg">
//                     BentoBox delivers across our defined service zones—if you're within the active delivery patch, we'll reach you.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Right Column */}
//             <div className="space-y-12">
              
//               {/* Policy Item 3 */}
//               <div className="flex items-start space-x-6 group">
//                 <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
//                   <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                 </div>
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-amber-600 transition-colors">
//                     Handling Delays
//                   </h3>
//                   <p className="text-gray-600 text-base leading-relaxed lg:text-lg">
//                     If delays occur due to traffic, weather, or unforeseen circumstances, our app notifies you immediately.
//                   </p>
//                 </div>
//               </div>

//               {/* Policy Item 4 */}
//               <div className="flex items-start space-x-6 group ml-12">
//                 <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-600 rounded-2xl flex items-center justify-center transform group-hover:rotate-12 transition-transform duration-300">
//                   <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
//                   </svg>
//                 </div>
//                 <div className="flex-1">
//                   <h3 className="text-2xl font-bold text-gray-800 mb-3 group-hover:text-purple-600 transition-colors">
//                     Contact Support Anytime
//                   </h3>
//                   <p className="text-gray-600 text-base leading-relaxed lg:text-lg">
//                     Need help or have a question? Our support team is just a tap away from inside the app.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Bottom CTA with Organic Shape */}
//         <div className="mt-24 relative">
//           <div className="max-w-4xl mx-auto text-center">
//             <div className="relative bg-gradient-to-r from-blue-600 via-purple-600 to-blue-700 rounded-[3rem] px-12 py-16 transform -rotate-1 hover:rotate-0 transition-transform duration-500">
//               <h2 className="text-3xl font-bold text-white mb-6">
//                 Questions About Delivery?
//               </h2>
//               <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
//                 Our customer support team is always ready to help ensure your BentoBox experience is perfect.
//               </p>
//               <button className="bg-white text-blue-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-blue-50 transform hover:scale-105 transition-all duration-300 shadow-xl">
//                 Contact Support
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default DeliveryPolicy
